import { PfeBaseActionConfig } from '../pfe-actions.model';
import { StateUpdates } from './../../models/navigation-config.model';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PfeUpdateStateValuesType = 'UPDATE_STATE_VALUES';

export interface PfeUpdateStateValuesActionConfig extends PfeBaseActionConfig {
  /**
   * This action provides the same functionality as the state updates.
   * The functionality is closer explained in the "Update State from Config" section in the documentation
   */
  type: typeof PfeUpdateStateValuesType;
  stateUpdates: StateUpdates[];
}
